export default {
    pixels_keys: [],
    pixels_key: [
        null
    ],
    pixels_value: [
        null
    ]
}